import AslInterpreterCheckbox from 'components/visit-creation/AslInterpreterCheckbox'
import withFeatureFlagToggle from '../withFeatureFlagToggle'

const EmptyView = (): null => null

const AslInterpreterCheckboxToggle = withFeatureFlagToggle('tcAslInterpreter')(AslInterpreterCheckbox, EmptyView)

export default AslInterpreterCheckboxToggle
